/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import TwoStepForm from '../components/TwoStepForm';

import useCarsData from '../hooks/useCarsData';
import useStationsData from '../hooks/useStationsData';
import useConfigData from '../hooks/useConfigData';
import useSocialMediaData from '../hooks/useSocialMediaData';
import useLegalUrl from '../hooks/useLegalUrl';
import useModelUrl from '../hooks/useModelUrl';

const Cotizador = ({legal_url_path, model_url_path, car_id, uf_value}) => {
    const { getCars, setSelectedCar, cars } = useCarsData();
    const { getConfig } = useConfigData();
    const {setModelUrl} = useModelUrl();
    const {setLegalUrl} = useLegalUrl();
    const {getSocialMedia } = useSocialMediaData();
    const { getStations } = useStationsData();
        
    useEffect(() => {
        getCars();
        getStations();
        getConfig();
        setLegalUrl(legal_url_path);
        getSocialMedia()
        setModelUrl(model_url_path);
    }, []);

    // Efecto separado para pre-seleccionar el auto cuando los autos estén cargados
    useEffect(() => {
        if (car_id && cars.length > 0) {
            setSelectedCar(car_id);
        }
    }, [cars, car_id]);


    return (
        <section className='cotizador one_personal' id='cotizador'>
            <div className='container'>
                <TwoStepForm uf_value={uf_value} />
            </div>
        </section>
    );
}

export default Cotizador;
